import { CommonSettingsProps } from 'approot/activity-builder/activity-builder.constants';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import { ComponentResponse } from '../component.constants';
import { ZoomComponentModalProps } from 'approot/activity-builder/activity-builder-zoom-component-modal.constants';
import {
  COLOUR_GREEN,
  COLOUR_ORANGE,
  COLOUR_RED,
} from 'approot/shared/colour/colour.constants';
import type { Pluck } from 'lib/gql/pluck';

export type ViewProps = Omit<ComponentResponse, '__typename'> &
  ZoomComponentModalProps;
export type SettingsProps = ViewProps & CommonSettingsProps;

export const typename = 'ActivitiesResponseComponent';
export type ResponseProperties = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesResponseComponent' }
  >,
  'properties'
>;

export const PRINT_LINE_HEIGHT = 72;

export type Field = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesResponseComponent' }
  >,
  'properties.textResponse.fields'
>;

export const COLOURS = [COLOUR_RED, COLOUR_ORANGE, COLOUR_GREEN];
